import React, { useState } from 'react'

import SearchHeader from './SearchHeader.jsx'

/**
 * @typedef {Object} FiltersPreviewProps
 * @property {() => void} onClick
 */

/**
 * Full route search layout.
 * @param {Object} props
 * @param {boolean} [props.filtersChanged] If filters differ from the default
 * @param {() => React.ReactNode} props.renderLocationSearch
 * @param {() => React.ReactNode} props.renderResultsCount
 * @param {() => React.ReactNode} [props.renderSortField]
 * @param {(props: import("./SearchHeader").FilterButtonProps) => React.ReactNode} props.renderFiltersButton
 * @param {() => React.ReactNode} props.renderFilters
 * @param {(props: FiltersPreviewProps) => React.ReactNode} props.renderFiltersPreview
 * @param {() => React.ReactNode} props.renderPrimaryFilters
 * @param {() => React.ReactNode} props.renderResults
 * @param {() => React.ReactNode} props.renderViewSelector
 */
const RouteSearch = ({
    filtersChanged, renderLocationSearch, renderResultsCount, renderSortField, renderFiltersButton,
    renderFilters, renderFiltersPreview, renderPrimaryFilters, renderResults, renderViewSelector,
}) => {
    const [filtersShown, setFiltersShown] = useState(false)

    const headerProps = {
        renderResultsCount,
        renderSortField,
        renderFiltersButton,
        filtersShown,
        onFiltersClick: setFiltersShown,
    }

    return (
        <>
            <div className='location-search-container'>
                {renderLocationSearch()}
                {renderViewSelector()}
            </div>
            <SearchHeader {...headerProps} />
            {filtersShown ? renderFilters() : filtersChanged && (
                renderFiltersPreview({ onClick: () => setFiltersShown(true) })
            )}
            {renderPrimaryFilters()}
            {renderResults()}
        </>
    )
}

export default RouteSearch
